import React from 'react'

// Style sheet
import 'bootstrap/dist/css/bootstrap.min.css';
import '../scss/topNavbar.scss'

// import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from "react-bootstrap";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
// import NavDropdown from 'react-bootstrap/NavDropdown';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

// Custom resources
import watermark from '../../../../resources/image/watermark.jpg'

type Props = {}

function TopNavbar() {
  return (
      <Navbar expand="lg" bg="primary" id='topNavbar' className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/">
            <img src={watermark} width="65" height="65" alt="PM icon"></img>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className='justify-content-end'>
          <Nav className="ms-auto">
            <Nav.Link href="/" className='navtop-link'>主頁</Nav.Link>
            <Nav.Link href="/oceanweather" className='navtop-link'>海洋氣象</Nav.Link>
            {/* <Nav.Link href="/about">社交媒體</Nav.Link> */}
            <Nav.Link href="/about" className='navtop-link'>關於</Nav.Link>
            

            {/* <Link to="/about">關於</Link> */}
            {/* <Nav.Link href="">網站更新動態</Nav.Link> */}
            
            {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default TopNavbar;